/**
 * Stepping through search hits (#627).
 *
 * Both highlighting paths end up with `<mark>` elements in the preview
 * subtree — the PDF text layer marks its items while rendering, the DOM
 * renderers are marked afterwards — so navigation reads the DOM and works for
 * either without knowing which produced them.
 */

export const HIT_SELECTOR = 'mark.preview-search-hit, mark.pdf-search-hit'
export const ACTIVE_HIT_CLASS = 'is-active-hit'

/** Every hit in document order. */
export function collectHits(root: HTMLElement): HTMLElement[] {
  return Array.from(root.querySelectorAll<HTMLElement>(HIT_SELECTOR))
}

/**
 * Marks exactly one hit as the current one.
 *
 * Clearing runs over the whole root rather than over `hits`, so a mark left
 * behind by a stale collection (a PDF page that re-rendered between two
 * passes) cannot keep the active styling.
 */
export function setActiveHit(root: HTMLElement, hits: HTMLElement[], index: number): HTMLElement | null {
  root.querySelectorAll<HTMLElement>(`.${ACTIVE_HIT_CLASS}`).forEach((el) => {
    el.classList.remove(ACTIVE_HIT_CLASS)
  })
  const active = hits[index] ?? null
  active?.classList.add(ACTIVE_HIT_CLASS)
  return active
}

/** Wraps around at both ends — stepping past the last hit returns to the first. */
export function stepIndex(current: number, total: number, delta: number): number {
  if (total <= 0) return 0
  return (current + delta + total) % total
}
